/** Configurable sidebar pages (backend `PageKey`). Dashboard and My Profile are always on. */
export const PAGE_KEYS = [
  'clients',
  'services',
  'notifs',
  'eng',
  'billing',
  'pwmgr',
  'users',
  'duedates',
  'audit',
] as const;

export type ConfigurablePage = (typeof PAGE_KEYS)[number];

export const PAGE_LABELS: Record<ConfigurablePage, string> = {
  clients: 'Client Master',
  services: 'Services',
  notifs: 'Inbox',
  eng: 'Documents',
  billing: 'Billing',
  pwmgr: 'Password Manager',
  users: 'User Management',
  duedates: 'Due Date Master',
  audit: 'Audit History',
};

export const ACCESS_LEVEL_LABELS = {
  admin: 'Admin',
  user: 'User',
} as const;
